import { Component } from 'react'

import * as h from 'h'

import { smartDate } from 'utils'

import styles from './styles.scss'

export default class Dates extends Component {
  render () {
    const { story } = this.props

    const eventDate = smartDate(story.eventDate, true)
    const eventEndDate = smartDate(story.endDate, true)

    return eventDate && (
      h.p(h.ca('small', styles.eventDate),
        eventDate,
        eventEndDate && ` – ${eventEndDate}`)
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/NewsEvents/Dates.js